// The "4 Gears of AI Usage" maturity model — the single source of truth.
//
// Ordered bottom -> top of the pyramid, so index 0 (Chat) is the wide base and
// index 3 (Loops) is the apex. Consumed by the presentation reveal on
// /ai-mastermind/four-gears and by the compact ladder on the home page, so the gear names,
// copy and accent colours stay identical wherever the model appears.
export interface Gear {
  n: number;
  name: string;
  // Simplified "when to use" and "how to use it" statements, each shown as a
  // plain-text line under a matching label. The product name inside `how` is a
  // deep link to the exact hands-on step on /claude-masterclass that teaches it.
  when: string;
  how: { before: string; product: string; href: string; after: string };
  accent: string;
}

export const FOUR_GEARS: Gear[] = [
  {
    n: 1,
    name: "Chat",
    when: "Use when you need a quick answer or idea.",
    how: {
      before: "Ask ",
      product: "Claude Chat",
      href: "/claude-masterclass#step-3",
      after: " a question.",
    },
    accent: "#F0A46A", // peach
  },
  {
    n: 2,
    name: "Assistant",
    when: "Use when you need a document made.",
    how: {
      before: "Have ",
      product: "Claude Chat",
      href: "/claude-masterclass#step-11",
      after: " make it for you.",
    },
    accent: "#EBCB55", // yellow
  },
  {
    n: 3,
    name: "Agents",
    when: "Use when you need a multi-step task done.",
    how: {
      before: "Hand the task to ",
      product: "Claude Cowork",
      href: "/claude-masterclass#step-26",
      after: ".",
    },
    accent: "#5FC6D8", // cyan
  },
  {
    n: 4,
    name: "Loops",
    when: "Use when you need a system that runs itself.",
    how: {
      before: "Set it up once in ",
      product: "Claude Code",
      href: "/claude-masterclass#step-39",
      after: ".",
    },
    accent: "#77C58A", // green
  },
];

export const GEAR_COUNT = FOUR_GEARS.length;

// Convert a #RRGGBB hex to an rgba() string so accents can be tinted at low alpha.
export const gearRgba = (hex: string, alpha: number) => {
  const h = hex.replace("#", "");
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
